import { render } from "./CovidMaskLayoutEditor.vue?vue&type=template&id=93972c78&ts=true"
import script from "./CovidMaskLayoutEditor.vue?vue&type=script&lang=ts"
export * from "./CovidMaskLayoutEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__